import React from 'react';
import { Navigate } from 'react-router-dom';
import LoginModal from '../components/LoginModal';
import { useAuth, hasValidAuth } from '../auth/authContext';

export default function DesktopLoginPage() {
  const { isAuthenticated, authLoading } = useAuth();
  const ready = !authLoading;

  if ((ready && isAuthenticated) || (authLoading && hasValidAuth())) {
    return <Navigate to="/admin" replace />;
  }

  return <LoginModal isOpen mode="page" onClose={() => {}} />;
}
